/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuButton } from '@neutron/react';

export const StyledClearFilterBtn = styled(NeuButton)`
  > button {
    font-size: 1rem;
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }
`;
